'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactVirtualized = require('react-virtualized');

require('react-virtualized/styles.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WPReTable = function (_Component) {
  _inherits(WPReTable, _Component);

  function WPReTable(props) {
    _classCallCheck(this, WPReTable);

    var _this = _possibleConstructorReturn(this, (WPReTable.__proto__ || Object.getPrototypeOf(WPReTable)).call(this, props));

    _this.state = {
      disableHeader: false,
      headerHeight: 30,
      height: _this.props.customStyle ? _this.props.customStyle.height : 270,
      hideIndexRow: false,
      overscanRowCount: 10,
      rowHeight: 40,
      scrollToIndex: undefined,
      sortBy: 'index',
      sortDirection: _reactVirtualized.SortDirection.ASC,
      useDynamicRowHeight: false
    };

    _this._noRowsRenderer = _this._noRowsRenderer.bind(_this);
    _this._rowClassName = _this._rowClassName.bind(_this);
    _this._getRowHeight = _this._getRowHeight.bind(_this);
    _this._getDatum = _this._getDatum.bind(_this);
    _this._sort = _this._sort.bind(_this);

    return _this;
  }

  _createClass(WPReTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          disableHeader = _state.disableHeader,
          headerHeight = _state.headerHeight,
          height = _state.height,
          hideIndexRow = _state.hideIndexRow,
          overscanRowCount = _state.overscanRowCount,
          rowHeight = _state.rowHeight,
          scrollToIndex = _state.scrollToIndex,
          sortBy = _state.sortBy,
          sortDirection = _state.sortDirection,
          useDynamicRowHeight = _state.useDynamicRowHeight;
      var list = this.props.list;

      var sortedList = this._isSortEnabled() ? list.sortBy(function (item) {
        return item[sortBy];
      }).update(function (list) {
        return sortDirection === _reactVirtualized.SortDirection.DESC ? list.reverse() : list;
      }) : list;
      var rowGetter = function rowGetter(_ref) {
        var index = _ref.index;
        return _this2._getDatum(sortedList, index);
      };
      var rowCount = list.size;
      console.log('List', rowCount);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactVirtualized.AutoSizer,
          { disableHeight: true },
          function (_ref2) {
            var width = _ref2.width;
            return _react2.default.createElement(
              _reactVirtualized.Table,
              {
                id: 'wpr_tbl',
                disableHeader: disableHeader,
                headerClassName: 'headerColumn',
                headerHeight: headerHeight,
                height: height,
                overscanRowCount: overscanRowCount,
                noRowsRenderer: _this2._noRowsRenderer,
                rowClassName: _this2._rowClassName,
                rowHeight: useDynamicRowHeight ? _this2._getRowHeight : rowHeight,
                rowGetter: rowGetter,
                rowCount: rowCount,
                scrollToIndex: scrollToIndex,
                sort: _this2._sort,
                sortBy: sortBy,
                sortDirection: sortDirection,
                width: width
              },
              _this2.renderColumnFromConfig()
            );
          }
        )
      );
    }
  }, {
    key: '_noRowsRenderer',
    value: function _noRowsRenderer() {
      return _react2.default.createElement(
        'div',
        { className: 'noRows' },
        'There\'s nothing here, yet.'
      );
    }
  }, {
    key: '_rowClassName',
    value: function _rowClassName(_ref3) {
      var index = _ref3.index;

      if (index < 0) {
        return 'headerRow';
      } else {
        return index % 2 === 0 ? 'evenRow' : 'oddRow';
      }
    }
  }, {
    key: '_getDatum',
    value: function _getDatum(list, index) {
      console.log("Data", list.get(index));
      return list.get(index);
    }
  }, {
    key: '_isSortEnabled',
    value: function _isSortEnabled() {
      return true;
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(_ref4) {
      var index = _ref4.index;
      var list = this.state.list;

      return this._getDatum(list, index).size;
    }
  }, {
    key: '_sort',
    value: function _sort(_ref5) {
      var sortBy = _ref5.sortBy,
          sortDirection = _ref5.sortDirection;

      this.setState.apply(this, _toConsumableArray(this.state).concat([{ sortBy: sortBy, sortDirection: sortDirection }]));
    }
  }, {
    key: 'renderColumnFromConfig',
    value: function renderColumnFromConfig() {
      var config = this.props.config;

      return config.columnsConfig.map(function (c) {
        if (c.cellRenderer) {
          return _react2.default.createElement(_reactVirtualized.Column, _extends({
            key: c.dataKey,
            label: c.label,
            dataKey: c.dataKey,
            disableSort: c.disableSort,
            width: c.width,
            cellRenderer: c.cellRenderer
          }, c));
        } else {
          return _react2.default.createElement(_reactVirtualized.Column, {
            key: c.dataKey,
            label: c.label,
            dataKey: c.dataKey,
            disableSort: c.disableSort,
            width: c.width
          });
        }
      });
    }
  }]);

  return WPReTable;
}(_react.Component);

/**
 * Column configuration class
 */


exports.default = WPReTable;

var ColumnConfig = exports.ColumnConfig = function ColumnConfig(label, dataKey, disableSort, width, cellRenderer, headerRenderer) {
  _classCallCheck(this, ColumnConfig);

  this.label = label;
  this.dataKey = dataKey;
  this.disableSort = disableSort;
  this.width = width;
  this.cellRenderer = cellRenderer;
  this.headerRenderer = headerRenderer;
};